<template>
  <v-snackbar v-model="visible" :timeout="-1" top data-cy="update-toast">
    {{ $t('content') }}

    <template v-slot:action="{ attrs }">
      <v-btn color="blue" text v-bind="attrs" @click="refresh">
        {{ $t('actions.refresh') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import notificationMixin from '../notification-mixin'

export default {
  name: 'UpdateFoundNotification',
  mixins: [notificationMixin('updateFound')],
  methods: {
    refresh () {
      location.reload(true);
    }
  }
}
</script>

<i18n>
{
	"en": {
		"content": "An update is available, click on refresh to use the new version."
	},
	"es": {
		"content": "Hay una actualización disponible, haga clic en actualizar para usar la nueva versión."
	},
	"fr": {
		"content": "Une mise à jour est disponible, cliquez sur rafraîchir pour utiliser la nouvelle version."
	},
	"it": {
		"content": "È disponibile un aggiornamento, clicca su aggiorna per usare la nuova versione."
	},
	"pt": {
		"content": "Está disponível uma atualização, clique em atualizar para utilizar a nova versão."
	},
	"pl": {
		"content": "Dostępna jest aktualizacja, kliknij odśwież, aby korzystać z nowej wersji."
	}
}
</i18n>
